import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {DropDownComponent, DropDownItem, IDropDownSelectionResult} from "./drop-down.component";
import {Check, TimeSpan} from "@sparkware/app-utils";
import {NullableNumber} from "../../../../../common/types/nullable-types";
import {TranslationsHelper} from "../../../../services/translation/translations-helper";
import {parseCommaSeparatedNumbers} from "../../../../../utils/string-helpers";
import {observer} from "mobx-react";
import {CyClass} from "../../../../../common/cy-classes";
import {DialogButtonClickHandleResultEnum} from "../../../../services/dialog/dialog.service.interface";

interface TimeLimitDropDownComponentProps {
    onItemSelected: (value: NullableNumber) => void;
    errorMessage?: string;
    className?: string;
}

export const TimeLimitDropDownComponent = observer(
    class TimeLimitDropDownComponent extends OrbitComponent<TimeLimitDropDownComponentProps> {

        private get _translations(): TranslationsHelper {
            return new TranslationsHelper(this.services.translation);
        }

        private _translateTimeSpan(timeSpan: TimeSpan): string {
            return timeSpan.totalMinutes < 60 ? this._translations.minutes(timeSpan.totalMinutes) : this._translations.hours(timeSpan.totalHours)
        }

        private _parseMaxDurations(): number[] {
            if(this.services.device.os.isMobileOS) {
                return parseCommaSeparatedNumbers(this.services.configuration.servicesConfigs.Regulation.Spain.MaxDurationsInMinutesForMobile);
            } else {
                return parseCommaSeparatedNumbers(this.services.configuration.servicesConfigs.Regulation.Spain.MaxDurationsInMinutesForPC);
            }
        }

        private _getDropDownItems(): DropDownItem[] {
            return this._parseMaxDurations().map(minutes => {
                const timeSpan = TimeSpan.fromMinutes(minutes);
                return {
                    value: timeSpan.totalSeconds,
                    text: this._translateTimeSpan(timeSpan)
                };
            });
        }
        private _onItemSelectedHandler = (value: NullableNumber): Promise<IDropDownSelectionResult> => {
            return new Promise<IDropDownSelectionResult>((resolve) => {

                const cancelSelection = () => {
                    resolve({
                        cancel: true
                    });
                }

                const acceptSelection = () => {
                    resolve({
                        cancel: false
                    });
                    this.props.onItemSelected(value);
                }

                if(Check.isNullOrUndefined(value) || value !== Math.min(...this._parseMaxDurations())) {
                    acceptSelection();
                } else {
                    this.services.dialog.showSimpleTextModal({
                        hideCloseButton: true,
                        title: this.services.translation.translate('ATTENTION'),
                        text: this.services.translation.translate('GAMBLING_SESSION_LIMIT_TIME_LOSS_CONFIRMATION_TEXT', {time: this._translateTimeSpan(TimeSpan.fromMinutes(value))})
                                + '\n\n\n'
                                + this.services.translation.translate('GAMBLING_SESSION_LIMIT_TIME_LOSS_CONFIRMATION_QUESTION'),

                        buttons: [
                            {
                                text: this.services.translation.translate('NO'),
                                buttonPreset: 'info',
                                onClick: async () => {
                                    cancelSelection();
                                    this.services.analytics.sendAnalytics('spain_limit_window_minimal_time_message', 'no');
                                    return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                                }
                            },
                            {
                                text: this.services.translation.translate('YES'),
                                buttonPreset: 'info',
                                onClick: async () => {
                                    acceptSelection();
                                    this.services.analytics.sendAnalytics('spain_limit_window_minimal_time_message', 'yes');
                                    return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                                }
                            }
                        ]
                    })
                }


            });
        }

        render() {
            return (
                <DropDownComponent label={this.services.translation.translate('GAMBLING_SESSION_TIME_LIMIT_DROP_DOWN_LABEL')}
                                   items={this._getDropDownItems()}
                                   nullItemText={this.services.translation.translate('SELECT')}
                                   onItemSelected={this._onItemSelectedHandler}
                                   errorMessage={this.props.errorMessage}
                                   className={CyClass('cy-gambling-session-limit-duration-select')}/>
            );
        }
    }
);